import React from 'react'
import { NumberParam, useQueryParams } from 'use-query-params'

export const useGeneralInvoicesQueryParam = () => {
  const [query, setQuery] = useQueryParams(
    {
      page: NumberParam,
    },
    { removeDefaultsFromUrl: true }
  )

  const { page, ...restQuery } = query

  const filters = {
    ...restQuery,
  }

  const onPageChange = (page?: number) => {
    setQuery({ page })
  }

  const onFiltersChange = (data?: object) => {
    const params = {
      ...data,
    }

    setQuery({ page: undefined, ...params })
  }

  return {
    query,
    setQuery,
    page,
    onPageChange,
    filters,
    onFiltersChange,
  }
}
